import { GInlineCenter } from '~/presentation/ui';
import { useTranslation } from 'react-i18next';
import { Text } from '@shopify/polaris';

export const NoData: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GInlineCenter minHeight="200px" align="center" inlineAlign="center">
      <Text as="p">{t('No orders found.')}</Text>
    </GInlineCenter>
  );
};
